import { render, staticRenderFns } from "./PintuanList.vue?vue&type=template&id=a34ce48c&scoped=true"
import script from "./PintuanList.vue?vue&type=script&lang=js"
export * from "./PintuanList.vue?vue&type=script&lang=js"
import style0 from "./PintuanList.vue?vue&type=style&index=0&id=a34ce48c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34ce48c",
  null
  
)

export default component.exports